import { httpCreate } from './http';

const http = httpCreate('/srv/black-list'); // 新接口
const httpOld = httpCreate('/srv/blackList'); // 旧接口
// 备注：此处以前公用旧版的接口，目前editBlackUser接口没改变，只有别的变了

export const blackList = {
	//pageNum, pageSize
	getBlackList(activityId, params) {
		return http.get(`/activity/${activityId}`, { params });
	},
	addBlackList(activityId, data) {
		return http.post(`/activity/${activityId}`, data);
	},
	editBlackUser(id, data) {
		return httpOld.put(`/${id}`, data);
	},
	unlock(activityId, data) {
		return http.post(`/comment/unlock/${activityId}`, data);
	},
	getBlackLevel() {
		return http.get('/admin/activity');
	},
	addUser(data) {
		return http.post(`/admin`, data);
	},
	addActivity(data) {
		return http.post(`/admin/activity`, data);
	},
	confirmBlack(id) {
		return http.put(`/admin/confirm/${id}`);
	},
	// 添加黑名单-单个
	singleAdd(body) {
		return http.post(`/single-add`, body);
	},
	// 添加黑名单-批量
	batchAdd(body) {
		return http.post(`/batch-add`, body);
	},
	// 通过黑名单id 解除黑名单
	removeByBid(body) {
		return http.post(`/remove/bid`, body);
	},
	// 通过用户id 解除黑名单
	removeByUid(body) {
		return http.post(`/remove/uid`, body);
	},
	// 获取单个用户的封禁记录
	getListByUid(userId, params) {
		return http.get(`/list/${userId}`, { params });
	},
};
